import React from 'react'
import { useState, useEffect } from "react";
import { useContext } from 'react';
import NhlGamesContext from './context/Context';
import SingleGame from './SingleGame';


function NHLGames() {

    const {favorites} = useContext(NhlGamesContext)
    const [NHLGames, setNHLGames] = useState([])
    const [display, setDisplay] = useState(false)
    const [currentDate, setCurrentDate] = useState(null)

    // Smart default date logic
    useEffect(() => {
      const determineDefaultDate = async () => {
        const now = new Date();
        const today = now.toJSON().slice(0, 10);

        try {
          // Fetch today's games to check start times
          const response = await fetch(`https://hehe.nhlrecap.com/?https://api-web.nhle.com/v1/score/${today}`, {
            headers: {
              'x-cors-api-key': 'temp_ec89abfc07d1cd3d760c3e4397975d32'
            }
          });
          const data = await response.json();

          if (data.games && data.games.length > 0) {
            // Find the earliest game today
            const earliestGame = data.games.reduce((earliest, game) => {
              const gameTime = new Date(game.startTimeUTC);
              const earliestTime = new Date(earliest.startTimeUTC);
              return gameTime < earliestTime ? game : earliest;
            });

            const gameStartTime = new Date(earliestGame.startTimeUTC);
            const timeUntilGame = (gameStartTime - now) / (1000 * 60); // minutes

            // If game starts within 30 minutes or already started, show today
            if (timeUntilGame <= 30) {
              setCurrentDate(today);
              return;
            }
          }
        } catch (error) {
          console.error('Error checking today\'s games:', error);
        }

        // Default to yesterday
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        setCurrentDate(yesterday.toJSON().slice(0, 10));
      };

      determineDefaultDate();
    }, []);

    useEffect(() => {
      if (currentDate) {
        GetNHLGames(currentDate);
      }
    }, [currentDate]);



    const GetNHLGames = async (date) => {
      setDisplay(false);

      try {
        // Fetch single date using new NHL API with CORS proxy
        const response = await fetch(`https://hehe.nhlrecap.com/?https://api-web.nhle.com/v1/score/${date}`, {
          headers: {
            'x-cors-api-key': 'temp_ec89abfc07d1cd3d760c3e4397975d32'
          }
        });
        const data = await response.json();

        // Transform to match expected structure with date grouping
        const formattedData = [{
          date: date,
          games: data.games || []
        }];

        setNHLGames(formattedData);
        setDisplay(true);
      } catch (error) {
        console.error('Error fetching NHL games:', error);
        setDisplay(true);
      }
    }

    const handlePreviousDay = () => {
      const prevDate = new Date(currentDate);
      prevDate.setDate(prevDate.getDate() - 1);
      setCurrentDate(prevDate.toJSON().slice(0, 10));
    };

    const handleNextDay = () => {
      const nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1);
      setCurrentDate(nextDate.toJSON().slice(0, 10));
    };


    function SortByFavorite(data) {
      var includes = []
      var notinclues = []
      /* const PlayerIDs = playergoals.map(pid => pid.id)
      const score = scoringplay.about.goals.home + ' - ' + scoringplay.about.goals.away
      const IsFinn = wantedIds.some( ai => PlayerIDs.includes(ai) ) */
      
        data.forEach(game => {
          // Updated for new API structure
          const TeamIDs = [game.awayTeam.id.toString(), game.homeTeam.id.toString()]

          const IsFav = favorites.some(ai => TeamIDs.includes(ai))

          IsFav ? includes.push(game) : notinclues.push(game)
        }
      )
      const sortedData = includes.concat(notinclues)
      return sortedData
    }

    const games = NHLGames.map(game => {
      let ts = new Date(game.date)
      return (
        <div key={game.date} >
        <h2 style={{margin: "1em"}}>{ts.toLocaleDateString()}</h2>
        <div key={game.date} className='game-day'>
        <SingleGame games={SortByFavorite(game.games)} key={game.date} />
        </div>
        </div>
      )
    })

    const formatDisplayDate = (dateStr) => {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };

    return (
      <div className="allgames">
        <div className="date-navigation">
          <button
            onClick={handlePreviousDay}
            className="date-nav-button"
          >
            ← Prev
          </button>

          <div className="date-display">
            {formatDisplayDate(currentDate)}
          </div>

          <button
            onClick={handleNextDay}
            className="date-nav-button"
          >
            Next →
          </button>
        </div>

        {display
        ? games
        :    <div className="spinner-container">
        <div className="loading-spinner">
        </div>
      </div>}
      </div>
    )
    
}

export default NHLGames